import { Motion, Presence } from "@motionone/solid"
import { Show, createEffect, createSignal, onCleanup, onMount } from "solid-js"
import { Portal } from "solid-js/web"
import { CloseButton } from "./CloseButton"
import { BackButton } from "./BackButton"
import { twMerge } from "tailwind-merge"

export const Modal = (props) => {
  return (
    <div class="fixed left-0 top-0 w-full h-full overflow-hidden bg-[rgba(4,25,9,0.9)] z-[999]">
      <div class="mx-auto flex flex-col max-w-6xl items-center sm:px-4 sm:pt-4 overflow-hidden">
        <div class="bg-[rgb(247 229 219)] mx-auto my-0 h-100v w-full overflow-hidden relative flex flex-col items-center" style="scroll-behavior: smooth; transform: translateZ(0)">
          <button class="close font-bold uppercase text-base font-bold w-4 h-4 absolute right-1 sm:right-2 md:right-2 top-1 sm:top-1 md:top-1 flex justify-end items-center z-[9999]" onclick="closeModal();">
            <svg class="w-2 h-2 md:w-3 md:h-3" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="2.50781" y="0.646447" width="32.3065" height="2.63466" transform="rotate(45 2.50781 0.646447)" fill="#2A2929" stroke="black" stroke-width="0.5" />
              <rect x="25.3536" y="2.50952" width="32.3065" height="2.63466" transform="rotate(135 25.3536 2.50952)" fill="#2A2929" stroke="black" stroke-width="0.5" />
            </svg>
          </button>
          <div class="w-full overflow-y-hidden" style="scroll-behavior: smooth;">
            <div class="flex justify-center">
              <div class="loader hidden mt-20 " id="blog-loader"></div>
            </div>
            <div class="overflow-y-auto  px-4 pb-10">
              {props.children}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export const ModalHeader = (props) => {
  return (
    <div
      class="px-2 border-b-outer border-frame w-full flex justify-between items-stretch"
    >

      <div
        class="flex relative flex-col justify-center items-center sm:w-fit "
      >
        <h3
          class="font-medium  py-2 text-lg" innerHTML={props.label}>

        </h3>
      </div>
      <Show when={props.closeButton} fallback={(
        <CloseButton
          className="py-2 border-l-outer border-frame pl-2"
          onClickHandler={props.closeModal}
        />
      )}>
        {props.closeButton((
          <CloseButton
            className="py-2 border-l-outer border-frame pl-2"
            onClickHandler={props.closeModal}
          />
        ))}
      </Show>
    </div>
  )
}

export const ModalV2 = (props) => {

  const style = {
    "z-index": "10000000",
    "background": "rgba(0, 0, 0, 0.75)"
  }

  const closeModal = () => {
    props.handleModalOpenState(false);
  }
  const showHeader = () => props.showHeader != undefined ? props.showHeader : true

  const handleEmptySpaceClick = (e) => {
    if (e.target.classList.contains("empty-parent")) {
      closeModal();
    }
  }

  onMount(() => {
    const close = (e) => {
      if (e.key === "Escape") {
        closeModal()
      }
    }
    document.addEventListener('keydown', close);
    onCleanup(() => {
      document.removeEventListener('keydown', close);
    })
  })

  return (
    <Portal>
      <Presence>
        <Show when={props.modalState}>
          <Motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0, y: 20 }}
            transition={{ duration: 0.2 }}
            style={style}
            class="h-full w-full fixed top-0 bottom-0 left-0 right-0 empty-parent"
            onClick={handleEmptySpaceClick}
          >

            <Motion.div
              initial={{ y: 100 }}
              animate={{ y: 0 }}
              exit={{ y: 200 }}
              transition={{ duration: 0.5 }}
              class={twMerge(
                `flex flex-col bg-canvas absolute items-center left-0 bottom-0 right-0 overflow-x-auto overflow-y-hidden scrollbar-hide mt-1 sm:w-full lg:w-1/2 sm:left-auto sm:h-full max-h-[100dvh]`,
                props.modalClass ?? ''
              )}
            // classList={{
            //   "h-full": selectedNavTab() == "size"
            // }}
            >
              <ModalHeader
                closeModal={closeModal}
                label={props.title}
                closeButton={props.closeButton}
              />
              <div class="w-full overflow-y-auto flex flex-col items-center h-full">
                <div
                  class="flex flex-col items-center w-full h-full"
                // classList={{
                //   "py-2": navBarData().selected != 'size',
                //   "pb-0": selectedMeasurementOption() == "measure-it-yourself" && selectedNavTab() == "size",
                // }}
                >

                  {/* <Dynamic
                    component={customizationModalData()[navBarData().selected]['element']}
                    {...customizationModalData()[navBarData().selected]['props']}
                  /> */}
                  {props.children}
                </div>
                <div
                  id="footer-banner"
                // classList={{
                //   "hidden": !(selectedNavTab() === "size")
                // }}
                >

                </div>
              </div>

            </Motion.div>


          </Motion.div>
        </Show>
      </Presence>
    </Portal>
  )
}

export const ModalV3 = (props) => {

  const style = {
    "z-index": "100000",
    "background": "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABdWlDQ1BrQ0dDb2xvclNwYWNlRGlzcGxheVAzAAAokXWQvUvDUBTFT6tS0DqIDh0cMolD1NIKdnFoKxRFMFQFq1OafgltfCQpUnETVyn4H1jBWXCwiFRwcXAQRAcR3Zw6KbhoeN6XVNoi3sfl/Ticc7lcwBtQGSv2AijplpFMxKS11Lrke4OHnlOqZrKooiwK/v276/PR9d5PiFlNu3YQ2U9cl84ul3aeAlN//V3Vn8maGv3f1EGNGRbgkYmVbYsJ3iUeMWgp4qrgvMvHgtMunzuelWSc+JZY0gpqhrhJLKc79HwHl4plrbWD2N6f1VeXxRzqUcxhEyYYilBRgQQF4X/8044/ji1yV2BQLo8CLMpESRETssTz0KFhEjJxCEHqkLhz634PrfvJbW3vFZhtcM4v2tpCAzidoZPV29p4BBgaAG7qTDVUR+qh9uZywPsJMJgChu8os2HmwiF3e38M6Hvh/GMM8B0CdpXzryPO7RqFn4Er/QcXKWq8UwZBywAAAFxlWElmTU0AKgAAAAgABAEGAAMAAAABAAIAAAESAAMAAAABAAEAAAEoAAMAAAABAAIAAIdpAAQAAAABAAAAPgAAAAAAAqACAAQAAAABAAAAEKADAAQAAAABAAAAEAAAAADmO95bAAACC2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNi4wLjAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3RpZmYvMS4wLyI+CiAgICAgICAgIDx0aWZmOlJlc29sdXRpb25Vbml0PjI8L3RpZmY6UmVzb2x1dGlvblVuaXQ+CiAgICAgICAgIDx0aWZmOk9yaWVudGF0aW9uPjE8L3RpZmY6T3JpZW50YXRpb24+CiAgICAgICAgIDx0aWZmOkNvbXByZXNzaW9uPjE8L3RpZmY6Q29tcHJlc3Npb24+CiAgICAgICAgIDx0aWZmOlBob3RvbWV0cmljSW50ZXJwcmV0YXRpb24+MjwvdGlmZjpQaG90b21ldHJpY0ludGVycHJldGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KlqhK0AAAAK5JREFUOBGNk0sOgzAMRK2oSCxaiSP0/pfiGuxaT+iEfOohSFGI8Hu2E2Lp+fiU8Vp229a3RY9/Sx5T4p21sriDKe0kp2AW/iMxlBSVvXo2DHLN/KvEFJz79QRK0ki5ANBslpIQ4jzAPKUZSQgLSWJmzEe9CN7vY/r+q+zRho+5eok4alNHxGOMMmcWQUqiYLDlVw4lY4O5av4nzWWakSCGMC7iJcBuq3a8kh6G4As0j1Qn0t5eCwAAAABJRU5ErkJggg==), rgba(0,0,0,0.3)",
    "background-size": "6px",
    "backdrop-filter": "grayscale(0%), brightness(.5)"
  }

  const closeModal = () => {
    props.handleModalOpenState(false);
  }

  const handleEmptySpaceClick = (e) => {
    if (e.target.classList.contains("empty-parent")) {
      closeModal();
    }
  }

  onMount(() => {
    const close = (e) => {
      if (e.key === "Escape") {
        closeModal()
      }
    }
    document.addEventListener('keydown', close);
    onCleanup(() => {
      document.removeEventListener('keydown', close);
    })
  })

  return (
    <Portal>
      <Presence>
        <Show when={props.modalState}>
          <Motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0, x: 20 }}
            transition={{ duration: 0.2 }}
            style={style}
            class="h-full w-full fixed top-0 bottom-0 left-0 right-0 empty-parent"
            onClick={handleEmptySpaceClick}
          >

            <Motion.div
              initial={{ x: 100 }}
              animate={{ x: 0 }}
              exit={{ x: 200 }}
              transition={{ duration: 0.5 }}
              class={twMerge(
                `mix-blend-normal shadow-lg bottom-0 absolute right-0  w-screen h-screen-actual max-w-[90vw] sm:max-w-sm bg-canvas border-frame  flex flex-col `,
                props.modalClass ?? ""
              )}
            // classList={{
            //   "h-full": selectedNavTab() == "size"
            // }}
            >
              <Show 
                when={props.isBacktrackHeader}
                fallback={(
                  <ModalHeader
                    closeModal={closeModal}
                    label={props.title}
                    closeButton={props.closeButton}
                  />
                )}
              >
                <StyleOptionModalHeader
                  closeModal={closeModal}
                  label={props.title} 
                />
              </Show>
              <div class="w-full overflow-y-auto flex flex-col items-center h-full themed-scrollbar">
                <div
                  class="flex flex-col items-center w-full h-full"
                >
                  {props.children}
                </div>
              </div>

            </Motion.div>


          </Motion.div>
        </Show>
      </Presence>
    </Portal>
  )
}

export const StyleOptionModalHeader = (props) => {
  return (
    <div
      class="px-2 gap-2 border-b-outer border-frame w-full flex justify-start items-stretch"
    >
      <BackButton className="py-2 border-r-outer border-frame pr-2"
        onClickHandler={props.closeModal} />
      <div
        class="flex relative flex-col items-center sm:w-fit justify-center"
      >

        <h3
          class="font-bold py-2 text-lg">
          {`${props.label}`}
        </h3>
      </div>

    </div>
  )
}